import { render, staticRenderFns } from "./LBlist.vue?vue&type=template&id=0900e3b0&"
import script from "./LBlist?vue&type=script&lang=ts&"
export * from "./LBlist?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports